
import React, { useEffect, useState } from "react";
import { Container, Table, Spinner, Pagination } from "react-bootstrap";
import categoryAPI from "../../../../services/categoryapi";
import moment from "moment";

const ViewCategory = ({ categoryId }) => {
    const [category, setCategory] = useState(null);
    const [statusLog, setStatusLog] = useState({ rows: [], count: 0 });
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const pageSize = 10;
    const [statusTypes, setStatusTypes] = useState({});

    useEffect(() => {
        if (categoryId) {
            fetchCategoryDetails();
        }
    }, [categoryId]);

    const fetchCategoryDetails = async () => {
        setLoading(true);
        try {
            const res = await categoryAPI.getCategoryById(categoryId);
            setCategory(res.data.category);
            if (res.data.statusLog) {
                setStatusLog({
                    rows: res.data.statusLog.rows,
                    count: res.data.statusLog.count,
                });

            }
            if (res.data.statusTypes) {
                setStatusTypes(res.data.statusTypes);
            }
        } catch (err) {
            console.error("Failed to fetch category details", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPaginatedLogs = async (pageNumber) => {
        setLoading(true);
        try {
            const res = await categoryAPI.getCategoryStatusLogs({
                categoryId,
                pageSize,
                page: pageNumber,
            });
            setStatusLog({
                rows: res.data.result,
                count: res.data.totalRecords,
            });
            setPage(pageNumber);
        } catch (err) {
            console.error("Failed to fetch logs", err);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (newPage) => {
        fetchPaginatedLogs(newPage);
    };

    const totalPages = Math.ceil(statusLog.count / pageSize);

    return (
        <Container>
            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" />
                </div>
            ) : (
                <>
                    <div className="d-flex justify-content-between align-items-start mb-4">
                        <div>
                            <h4>Category: {category?.categoryName}</h4>
                            <p><strong>Slug:</strong> {category?.slug}</p>
                            <p><strong>Parent ID:</strong> {category?.parentID || "Root"}</p>
                            <p><strong>Status:</strong> {category?.status === 1 ? "Active" : "Inactive"}</p>
                            <p><strong>Created At:</strong> {moment(category?.createdAt).format("YYYY-MM-DD HH:mm")}</p>
                            <p><strong>Updated At:</strong> {moment(category?.updatedAt).format("YYYY-MM-DD HH:mm")}</p>
                        </div>
                        <div className="text-end">
                            {category?.image && (
                                <div className="mb-3">
                                    <strong>Image:</strong>
                                    <img
                                        src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${category.image}`}
                                        alt="Category"
                                        width={120}
                                        className="d-block mt-1"
                                    />
                                </div>
                            )}
                            {category?.bannerImage && (
                                <div>
                                    <strong>Banner:</strong>
                                    <img
                                        src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${category.bannerImage}`}
                                        alt="Banner"
                                        width={200}
                                        className="d-block mt-1"
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {statusLog.rows.length > 0 && (
                        <>
                            <h5>Status Logs</h5>
                            <Table bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Old</th>
                                        <th>New</th>
                                        <th>Reason</th>
                                        <th>Updated By</th>
                                        <th>Updated At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {statusLog.rows.map((log, index) => (
                                        <tr key={log.id}>
                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                            <td>{statusTypes[log.old_status] || log.old_status}</td>
                                            <td>{statusTypes[log.new_status] || log.new_status}</td>
                                            <td>{log.reason}</td>
                                            <td>{log.updatedAdmin?.name || "-"}</td>
                                            <td>{moment(log.updated_at).format("YYYY-MM-DD HH:mm")}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            {statusLog.count > pageSize && (
                                <Pagination>
                                    <Pagination.Prev
                                        onClick={() => handlePageChange(page - 1)}
                                        disabled={page === 1}
                                    />
                                    {[...Array(totalPages)].map((_, i) => (
                                        <Pagination.Item
                                            key={i}
                                            active={i + 1 === page}
                                            onClick={() => handlePageChange(i + 1)}
                                        >
                                            {i + 1}
                                        </Pagination.Item>
                                    ))}
                                    <Pagination.Next
                                        onClick={() => handlePageChange(page + 1)}
                                        disabled={page === totalPages}
                                    />
                                </Pagination>
                            )}
                        </>
                    )}
                </>
            )}
        </Container>
    );
};

export default ViewCategory;
